import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { UpdateRoleActions } from 'store/ducks/roles';

export function* updateRoleRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/roles/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateRoleActions.success(data));
    notify('success', 'Tipo de usuário atualizado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(UpdateRoleActions.failure(errorMessage));
  }
}
